import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { URLS } from '@wix/da-url';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import RadioButton from '@wix/da-ds/pkg/RadioButton';
import DSModalLink from '@wix/da-ds/pkg/modals/dsPresets/ModalLink';
import CoreBadge from '@wix/da-ds/pkg/Badges/CoreBadge';
import TextTooltipOnHover from '../../../../../Popover/Preset/TextTooltipOnHover';
import s from './FolderTypeRadioButton.scss';
export var FolderTypeRadioButton = function (_a) {
    var value = _a.value, isSelected = _a.isSelected, onChange = _a.onChange, title = _a.title, hint = _a.hint, showCoreMembership = _a.showCoreMembership, showCoreUpgrade = _a.showCoreUpgrade, disabled = _a.disabled, biReferralType = _a.biReferralType, children = _a.children;
    var t = useTranslation().t;
    return (React.createElement(RadioButton, { name: "folderType", value: value, checked: isSelected(value), onChange: function () { return onChange(value); }, className: classnames(s['root'], disabled && s['disabled']), size: "small", disabled: disabled, withMargins: true },
        React.createElement("div", { className: s['label-block'] },
            React.createElement("div", { className: s['label-header'] },
                title,
                showCoreMembership && (React.createElement(TextTooltipOnHover, { tooltipText: t('mediapopup.newFolderPopup.gallery.premiumFolders.coreTooltip'), placement: 'right', secondaryPlacement: 'middle' },
                    React.createElement(CoreBadge, { className: s['core-banner'], size: "small" })))),
            React.createElement("div", { className: s['label-hint'] }, hint),
            children,
            showCoreUpgrade && (React.createElement("div", { className: s['core-cta'] },
                React.createElement(TextTooltipOnHover, { tooltipText: t('mediapopup.newFolderPopup.gallery.premiumFolders.coreTooltip'), placement: 'top', secondaryPlacement: 'middle' },
                    React.createElement(CoreBadge, { className: s['core-banner'], size: "large" })),
                ' ',
                React.createElement(Trans, { i18nKey: 'mediapopup.newFolderPopup.gallery.premiumFolders.coreUpgrade' },
                    "members only",
                    ' ',
                    React.createElement(DSModalLink, { href: URLS.CORE_MEMBERSHIP, biData: {
                            evid: BiEventType.BUY_CORE_BUTTON,
                            referral_info: biReferralType,
                        } }, "Upgrade")))))));
};
FolderTypeRadioButton.displayName = 'FolderTypeRadioButton';
export default FolderTypeRadioButton;
//# sourceMappingURL=FolderTypeRadioButton.js.map